var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import { Div } from "../utils";
import { SvgCheck } from "../Svgs/Check";
import { colors } from "../Theme/colors";
const CheckIcon = styled(SvgCheck) `
  height: 12px;
  width: 12px;
`;
const Container = styled(Div) `
  height: 14px;
  width: 14px;
  border: 1px solid ${(props) => props.theme.colors.black20};
  border-radius: 2px;
  ${(props) => props.isSelected &&
    css `
      border: 1px solid white;
      background-color: ${(props) => props.theme.colors.navy};
    `};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const CheckboxInput = (_a) => {
    var { isSelected, icon = null } = _a, props = __rest(_a, ["isSelected", "icon"]);
    return (React.createElement(Container, Object.assign({}, Object.assign({ isSelected }, props), { tabIndex: 0 }), isSelected &&
        (icon || (React.createElement(Div, { c: colors.white, svgFill: colors.white, alignCenter: true },
            React.createElement(CheckIcon, null))))));
};
//# sourceMappingURL=CheckboxInput.js.map